/**
 * Resolves a path inside `public/` against the deployment's base path.
 *
 * Vite's `BASE_URL` already carries a trailing slash ("/" in dev, "/admin/"
 * under a sub-path deploy), so `pathname` is given without a leading one.
 * Writing "/media/images/favicon.png" directly works only while the app is
 * served from the domain root, and breaks silently the moment `base` changes.
 */
export const toAbsoluteUrl = (pathname: string) => import.meta.env.BASE_URL + pathname;
